export const setHtmlDirection = (value) => {
  document.getElementsByTagName('html')[0].setAttribute('dir', value);
};
